var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('CKEditor',{attrs:{"content":_vm.getContent,"scope":"Pagina"},on:{"submit":_vm.set_content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }